// frontend/src/components/layout/AuthFooter.jsx
import React from "react";

export default function AuthFooter() {
  return (
    <footer className="bg-gray-50 border-t border-gray-200">
      <div className="container mx-auto px-4 py-4">
        {/* Links legales simplificados */}
        <div className="text-center text-xs text-gray-400 space-x-3">
          <a href="/termos" className="hover:text-[#449779] transition-colors">
            Termos de Uso
          </a>
          <span>•</span>
          <a href="/privacidade" className="hover:text-[#449779] transition-colors">
            Privacidade
          </a>
          <span>•</span>
          <a href="/ajuda" className="hover:text-[#449779] transition-colors">
            Ajuda
          </a>
        </div>
        
        {/* Copyright */}
        <p className="text-center text-[10px] text-gray-400 mt-2">
          © {new Date().getFullYear()} Brechó Vizinho
        </p>
      </div>
    </footer>
  );
}